<template>
  <div class="self_element_style_qja_a_this">
    <basic-container>
      <div class="form_wrapper">
        <div class="form_header">
          <div class="form_header_name">
            {{ title }}
          </div>
          <div class="form_header_remarks">
            带 <span class="red_color">* </span>为必填项
          </div>
        </div>
        <div class="form_content">
          <avue-form
            :option="option"
            ref="form"
            v-model="form"
            @submit="handleSubmit"
          >
            <template slot="group1Header">
              <div class="label_name">基础信息</div>
            </template>
            <template slot="projectName">
              <el-select
                v-model="form.projectName"
                @change="projectchange"
                value-key="id"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.projectName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </template>
            <template slot="group2Header">
              <div class="label_name">合同信息</div>
            </template>
          </avue-form>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>

import * as api from "@/api/zd/contract";
import { mapGetters } from "vuex";

import SelectPerson from "@/components/SelectPersonnel/person";
export default {
  name: "thirdRegister",
  data() {
    return {
      form: {},
      projectList: [],
      option: {
        labelWidth: 120,
        emptyBtn: false,

        group: [
          {
            icon: "el-icon-info",
            label: "分组1",
            prop: "group1",
            column: [
              {
                label: "所属项目",
                prop: "projectName",
                formslot: true,
                rules: [
                  {
                    required: true,
                    message: "请选择项目",
                    trigger: "blur"
                  }
                ]
              },
              {
                label: "合同名称",
                prop: "contractName",
                disabled: true,
                rules: [
                  {
                    required: true,
                    trigger: "blur"
                  }
                ]
              },
              {
                label: "客户名称",
                disabled: true,
                prop: "custName",
                mock: {
                  type: "name"
                },
                rules: [
                  {
                    required: true,
                    message: "请填写联系人",
                    trigger: "blur"
                  }
                ]
              },
              {
                label: "客户经理",
                prop: "managerName",
                disabled: true,
                slot: true,
                rules: [
                  {
                    required: true,
                    message: "请填写联系方式",
                    trigger: "blur"
                  }
                ]
              },
              {
                label: "申请银行",
                prop: "bankName",
                disabled: true,
                rules: [
                  {
                    required: true,
                    message: "请输入拜访名称",
                    trigger: "blur"
                  }
                ]
              }
            ]
          },
          {
            icon: "el-icon-info",
            label: "分组2",
            prop: "group2",
            column: [
              {
                label: "合同金额",
                prop: "quota",
                disabled: true,
                rules: [
                  {
                    required: true,
                    message: "合同编号",
                    trigger: "blur"
                  }
                ],
                formatter: (row, value, label, column) => {
                  return this.getMoney(value);
                }
              },
              {
                label: "使用天数",
                disabled: true,
                prop: "expectUseDay",

                rules: [
                  {
                    required: true,
                    message: "请选择合同期限",
                    trigger: "blur"
                  }
                ]
              },
              {
                label: "预计出款时间",
                prop: "expectPayDate",
                type: "date",
                format: "yyyy-MM-dd",
                valueFormat: "yyyy-MM-dd",
                rules: [
                  {
                    required: true,
                    message: "填写内容",
                    trigger: "blur"
                  }
                ],
                // pickerOptions: {
                //   disabledDate(time) {
                //     return time.getTime()+86400000< Date.now();;
                //   }
                // },
                dataType: "number"
              },

              {
                label: " 使用费率",
                disabled: true,
                prop: "loanRate",
                append: "%",
                rules: [
                  {
                    required: true,
                    message: "填写内容",
                    trigger: "blur"
                  }
                ]
              }
            ]
          }
        ]
      }
    };
  },

  components: {
    SelectPerson
  },
  computed: {
    ...mapGetters(["userInfo"]),
    title() {
      return this.$route.params.id === "-1" ? "新增合同" : "编辑合同";
    }
  },
  watch: {},
  created() {
    if (this.$route.params.id != -1) {
      this.onLoad(this.$route.params.id);
      this.id = this.$route.params.id;
    }

    this.form.managerUsername = this.userInfo.nick_name;
    
    this.getproject();
    // this.checkUserList.push(this.userInfo.user_id)

    // this.getInfo();
  },

  methods: {
    onLoad(id) {
      api
        .contractinfo({ id: id })
        .then(res => {
          
          // console.log(res.data.data);
          this.form = res.data.data;
           this.form.loanRate=res.data.data.loanRate*100
        })
        .catch(res => {
          
        });
    },
    getproject() {
      api.projectgetListDefault({ isContract: 1 ,myself:1}).then(res => {
        this.projectList = res.data.data;
        
      });
    },
    projectchange(data) {
      
      this.form.contractName = data.projectName + "转贷资金使用协议";
      this.form.custName = data.custName;
      this.form.managerName = data.managerName;
      this.form.bankName = data.bankName;
      this.form.quota = data.quota;
      this.form.expectUseDay = data.expectUseDay;
      this.form.expectPayDate = data.expectPayDate;
      this.form.loanRate = data.loanRate*100;
      this.form.projectId = data.id;
    },
    //提交
    handleSubmit() {
      
      this.$refs.form.validate(vaild => {
        if (vaild) {
          let data = {
            projectId: this.form.projectId,
            contractName: this.form.contractName,
            expectPayDate: this.form.expectPayDate,
            id: this.id
          };
          api.contractsubmit(data).then(res => {
            this.$router.push({
              path: "/zd/contractmanage/contractDetail/",
              query: { id: res.data.data }
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form_wrapper {
  height: 100%;
  // margin: 0 15%;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
.btn_save {
  text-align: center;
}
</style>

<style>
.self_element_style_qja_a_this .el-card.is-always-shadow {
  background-color: #f0f2f5;
}
.self_element_style_qja_a_this .el-button {
  width: 140px;
}
.self_element_style_qja_a_this .avue-group {
  pointer-events: none;
}
.self_element_style_qja_a_this .el-collapse-item__wrap {
  pointer-events: all;
}
</style>
